module.exports = __webpack_public_path__ + "img/hogwarts_letter.9793dd30.jpg";